import CityPageTemplate from "../city-template/CityPageTemplate";
import { goshenConfig } from "./data";

export default function GoshenPage() {
  return <CityPageTemplate config={goshenConfig} />;
}